import { Component } from '@angular/core';

@Component({
    selector: 'popup-button-container',
    styles: [
        `
            :host {
                display: inline-block;
                float: right;
            }
        `

    ],
    template: `
        <div class="cl-layout-padding button-container">
            <ng-content></ng-content>
        </div>
    `
})
export class PopupButtonContainerComponent {

}
